import show from './show';
import settings from './settings';
import chat from './chat';
import content from './content';
import nav from './nav';
import notifications from './notifications';
import user from './user';
import guest from './guest';
import conferencing from './conferencing';

import { generateRandomID } from '@/functions/utility.js'

const state = {
  showAlert: false,
  currentPopup: null,
  queue: [],
};

const getters = {
  ifShowAlert: (state) => state.showAlert,
  currentPopup: (state) => state.currentPopup,
  queue: (state) => state.queue,
};

const mutations = {
  SHOW_ALERT: (state, value) => state.showAlert = value,
  CURRENT_POPUP(state, data) {
    if (data) {
      data.setTime = Date.now();
      state.currentPopup = data;
    } else {
      state.currentPopup = null;
    }
  },
  ADD_TO_QUEUE(state,data) {
    let currentPopup = state.currentPopup
    if(currentPopup?.id === data?.id) return
    state.queue.push(data)
  },
  REMOVE_FROM_QUEUE(state,data) {
    let queue = state.queue
    if(queue && queue.length) {
      let queueWithoutItem = queue.filter(item => item?.id !== data?.id)
      state.queue = queueWithoutItem
    }
  },
};

const actions = {
  // alerts ----------------------------------------------------------
  showAlertMessage({ commit }, payload) {
    commit('SHOW_ALERT', payload);
  },
  // app status updates ----------------------------------------------
  async update({getters,commit}, data) {
    //add individual id to every popup
    let randId = generateRandomID()
    data.id = data.id ? `${data.id}-${randId}` : randId

    let statusPopup = getters.currentPopup
    if(statusPopup && statusPopup?.type !== 'processing' && data?.type !== 'processing') {
      //wait until current popup closes before showing next
      commit('ADD_TO_QUEUE', data)
    } else {
      //when setting status popup - remove new popup from queue (if added from queue)
      commit('CURRENT_POPUP',null)
      commit('REMOVE_FROM_QUEUE',data)
      commit('CURRENT_POPUP',data)
    }
  },
  async close({getters,commit,dispatch}) {
    //remove current popup from queue before closing
    let currentPopup = getters.currentPopup
    if(currentPopup) {
      commit('REMOVE_FROM_QUEUE',currentPopup)
    }
    commit('CURRENT_POPUP',null)
    //check if any more updates in queue to show next
    let statusQueue = getters.queue
    if(statusQueue.length) {
      dispatch('update',statusQueue[0])
    }
  },
};

export default {
	namespaced: true,
	modules: {
		show, settings, chat, content, nav, notifications, user, guest, conferencing
	},
	state,
  getters,
  mutations,
  actions
}
